import { move } from "fs-extra";
import { Vector2 } from "three";
import { DOMHitTest } from "../dom-tools/DOMHitTest";
import { Events, OnDrag, OnTouchDrag } from "../dom-tools/EventListeners";

export enum TouchGestureEventMoveType
{
  None,
  Horizontal,
  Vertical,
  Both
}

export class TouchGestureEvent
{
  type:string;
  offset:Vector2;
  position:Vector2;
  movement:Vector2;
  movementSinceStart:Vector2;
  maxMovementSinceStart:Vector2;
  delta:Vector2;
  numTouches:number;
  touchScale:number;
  touchChanged:boolean;
  eventReference:MouseEvent|TouchEvent;
  silentEvent:boolean
  movedSinceStart:boolean;
  moveType:TouchGestureEventMoveType;

  static readonly movementTreshold = 5;

  get xDistanceToStart()
  {
    return Math.abs( this.movementSinceStart.x )
  }

  get yDistanceToStart()
  {
    return Math.abs( this.movementSinceStart.x )
  }

  get xChangedToStart() 
  {
    return this.xDistanceToStart > TouchGestureEvent.movementTreshold;
  }

  get yChangedToStart() 
  {
    return this.yDistanceToStart > TouchGestureEvent.movementTreshold;
  }
}

export class TouchGesture
{
  
  static _getPoints( te:TouchEvent ):Vector2[]
  {
    let points:Vector2[] = [];
              
    for ( let i = 0; i < te.touches.length; i++ )
    {
      let t = te.touches[ i ];
      points.push( new Vector2( t.pageX, t.pageY ) );                 
    }

    return points;
  }

  static _computeRadius( points:Vector2[], center:Vector2 )
  {
    center.set( 0, 0 );

    points.forEach( p => center.add( p ) );

    center.multiplyScalar( 1.0 / points.length );

    let size = 0;

    points.forEach(
      p => 
      {
        size = Math.max( size, center.distanceTo( p ) );
      }
    )

    return size;
  }

  static enable( element:HTMLElement, callback:( tge:TouchGestureEvent  )=> void )
  {

    let offset:Vector2 = new Vector2();
    let lastPosition:Vector2 = new Vector2();
    let numTouches = 0;
    let cachedStartPositions:Vector2[] = [];
    let cachedPositions:Vector2[] = [];
    let pageStartPosition = new Vector2();
    let pageMovement = new Vector2();
    let touchScale = 1;
    let center = new Vector2();
    let moved = false;
    let movementTreshold = 5; 
    let moveType = TouchGestureEventMoveType.None;

    OnDrag.add( element, 
      ( e:TouchEvent|MouseEvent )=>
      {
        console.log( e );
        let pagePosition = DOMHitTest.getPointerPosition( e );

        if ( "mousedown" === e.type || "touchstart" === e.type )
        {
          offset = DOMHitTest.getRelativePointerPosition( e, element ) ;
          lastPosition = DOMHitTest.getRelativePointerPosition( e, element.parentElement );
          moved = false;
          moveType = TouchGestureEventMoveType.None;
          pageStartPosition = pagePosition.clone();
          pageMovement.set( 0, 0 );
        }
        else
        {
          pageMovement.copy( pageStartPosition ).sub( pagePosition );

          if ( ! moved && pageMovement.length() > movementTreshold )
          {
            let absX = Math.abs( pageMovement.x );
            let absY = Math.abs( pageMovement.y );
            moveType = absX > absY ? TouchGestureEventMoveType.Horizontal : TouchGestureEventMoveType.Vertical;
            moved = true;
          }
        } 
        

        let touchChanged = false;

        if ( /touch/.test( e.type ) )
        {
          let touchEvent = e as TouchEvent;
          let lastNumTouches = numTouches;
          numTouches = touchEvent.touches.length;

          if ( numTouches != lastNumTouches )
          {
            offset       = DOMHitTest.getRelativePointerPosition( e, element ) ;
            lastPosition = DOMHitTest.getRelativePointerPosition( e, element.parentElement );

            if ( numTouches > 1 )
            {
              cachedStartPositions = this._getPoints( touchEvent );
            }

            touchChanged = true;
          }

          let startRadius   = TouchGesture._computeRadius( cachedStartPositions, center );
          let currentRadius = TouchGesture._computeRadius( this._getPoints( touchEvent ), center );

          touchScale = currentRadius / startRadius;

        } 
        else
        {
          touchScale = 1;
        }
        
        

        let position = DOMHitTest.getRelativePointerPosition( e, element.parentElement );
        let delta = position.clone().sub( lastPosition );
        lastPosition.copy( position );

        let movement = position.clone().sub( offset );

        let event = new TouchGestureEvent();
        event.offset = offset.clone();
        event.position = position;
        event.movement = movement;
        event.movementSinceStart = pageMovement.clone();
        event.delta    = delta;
        event.numTouches = numTouches;
        event.touchScale = touchScale;
        event.touchChanged = touchChanged;      
        event.eventReference = e;
        event.silentEvent = true;
        event.movedSinceStart = moved;
        event.type = e.type;
        event.moveType = moveType;
        
       

        callback( event );

        
        if ( event.silentEvent )
        {
          //console.log( "SILENTING EVENT >>", e );
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();

          return false;
        }
      } 
    );
  }
}